import DragObject from './drag-object.js';

class ActionDrag {
    constructor(object, pointerPos) {
        let { x: pointX, y: pointY } = pointerPos;

        this._object = object;
        this._startPointerPos = { x: pointX, y: pointY };
        this._status = 'in-progress';

        let { x: objX, y: objY } = object.getPosition();
        this._startObjectPos = { x: objX, y: objY };
        this._currentObjectPos = { x: objX, y: objY };

        this._objectOffset = {
            x: objX - pointX,
            y: objY - pointY,
        };

        this._promise = new Promise((resolve, reject) => {
            this._resolvePromise = resolve;
        });
    }

    _assertInProgress() {
        if (this._status !== 'in-progress') throw new Error('action has already ended');
    }

    movePointer(pointerPos) {
        this._assertInProgress();

        let currentPos = this._currentObjectPos;
        let offset = this._objectOffset;

        currentPos.x = pointerPos.x + offset.x;
        currentPos.y = pointerPos.y + offset.y;

        this._object.setPosition(currentPos);
    }

    cancel() {
        this._assertInProgress();

        this._object.setPosition(this._startObjectPos);
        this._status = 'cancelled';
        this._resolvePromise({ status: 'cancelled' });
    }

    finish() {
        this._assertInProgress();

        let currentPos = this._currentObjectPos;
        this._status = 'finished';
        this._resolvePromise({ status: 'finished', position: currentPos });
    }

    get promise() { return this._promise; }
    get status() { return this._status; }
}

export default ActionDrag;
